export default "__VITE_ASSET__CBv9Lq2J__";